import React, { useState, useEffect, useRef } from "react";
import "./PaymentsHistory.css";
// components imports
import PaymentHistoryTable from "../../../../../Components/BoltTable/BoltTable";
import FullPageModal from "../../../../../Components/Modals/FullPageModal/FullPageModal";
import InvoiceModal from "../../../../../Components/InvoiceModal/InvoiceModal";
// apis imports
import { fetchTransactionswithuserID } from "../../../../../services/AdminServices/Users/users.services";
import {
  convertTime,
  removeUnderscoresAndCapitalize,
} from "../../../../../helpers/helpers";

// library imports
import CircularProgress from "@mui/material/CircularProgress";
import { FaArrowAltCircleUp, FaArrowAltCircleDown } from "react-icons/fa";
import { MdOutlineStickyNote2 } from "react-icons/md";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

const PaymentsHistory = ({ open, setOpen, User, setSnack }) => {
  const { t } = useTranslation("admin");
  // new code
  const [payments, setPayments] = useState([]);
  const [invoiceLoader, setinvoiceLoader] = useState(false);
  const [invoiceModal, setInvoiceModal] = React.useState();

  const columns = [
    {
      id: 1,
      label: t("users.transactionId"),
      render: (row) => <>{row?.transaction_no ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.method"),
      render: (row) => (
        <>
          {row.transaction_type
            ? removeUnderscoresAndCapitalize(row.transaction_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 3,
      label: t("users.paymentType"),
      render: (row) => (
        <>
          {row.payment_type
            ? removeUnderscoresAndCapitalize(row.payment_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("users.amount"),
      render: (row) => (
        <div
          style={{
            color: row?.transaction_type?.startsWith("credit")
              ? "teal"
              : "tomato",
            display: "flex",
          }}
        >
          <>
            {row.amount ?? "-"}
            {row?.transaction_type?.startsWith("credit") ? (
              <FaArrowAltCircleUp
                style={{ marginTop: "2px", marginLeft: "4px" }}
              />
            ) : (
              <FaArrowAltCircleDown
                style={{ marginTop: "2px", marginLeft: "4px" }}
              />
            )}
          </>
        </div>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("users.balance"),
      render: (row) => <>{row.user_balance ?? "-"}</>,
      width: "200px",
    },
    {
      id: 6,
      label: t("users.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("users.invoice"),
      render: (row) => (
        <div className="table_action__wrap">
          <div
            className={`table_action__btn   ${
              !row.shipment_id &&
              !row.formula_invoice &&
              !row.file &&
              "table_action__btn__disabled"
            }`}
            onClick={() => {
              if (row.shipment_id) {
                setInvoiceModal(row.shipment_id);
              } else {
                if (row.formula_invoice?.file) {
                  downloadPdf(row.id, row?.formula_invoice?.file);
                } else {
                  downloadPdf(row.id, row?.file);
                }
              }
            }}
          >
            {invoiceLoader === row.id ? (
              <CircularProgress size={10} />
            ) : (
              <MdOutlineStickyNote2 size={10} />
            )}
            {t("users.invoice")}
          </div>
        </div>
      ),
      width: "200px",
    },
    {
      id: 8,
      label: t("users.description"),
      render: (row) => <>{row.description ?? "-"}</>,
      width: "200px",
    },
  ];

  const getShippersPayments = async (page, perPage, filter) => {
    const response = await fetchTransactionswithuserID(
      User?.id,
      page,
      perPage,
      filter
    );

    if (!response.error) {
      setPayments(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const downloadPdf = async (id, urlfull) => {
    setinvoiceLoader(id);
    const urlParts = urlfull.split("/");
    const filename = urlParts[urlParts.length - 1];
    try {
      fetch(urlfull, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf",
        },
      })
        .then((url) => url.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setinvoiceLoader(false);
        });
    } catch (error) {
      setinvoiceLoader(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setinvoiceLoader(false);
    setInvoiceModal(false);
  };

  return (
    <>
      <InvoiceModal
        open={!!invoiceModal}
        data={invoiceModal}
        setOpen={setInvoiceModal}
        // type="editable"
        actions={false}
        id={User?.id}
      />
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div className="prdtable__hist_modal">
            <div
              className="prdtable__hist_modalheading history__product_heading  history__main_heading"
              style={{
                border: "none",
              }}
            >
              {t("users.transactionsHistory")}
            </div>
            <div className="prdtable__hist_modalheading history__product_heading history__sub_heading">
              {open?.username ?? ""} ({open?.business_name ?? ""})
            </div>
            <div className="prdtable__hist_modalcontent history__product_content">
              <PaymentHistoryTable
                tableId="paymentsHistoryTableForAdmin"
                message={t("users.noTransactionHistoryAvailableTo")}
                searchPlaceHolder={t("users.searchTransactions")}
                columns={columns}
                data={payments}
                getAllData={getShippersPayments}
                disableAutoResizing={true}
                maxHeight="100%"
              />
            </div>
            <div className=" history__product_footer">
              <div
                className="history__product_footer_btn"
                onClick={handleClose}
              >
                x
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default PaymentsHistory;
